// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"6844a064","735":"93a97e35","756":"8179943f","884":"6eefe85e"}[chunkId] + ".chunk.css";
};